import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User saves their trimmed video',
  name: 'save_video_edits',
  params: [
    {
      description: 'The type of save action',
      name: 'save_type',
      required: true,
      type: 'enum',
      values: ['new_asset', 'new_version'],
    },
  ],
};

export default META;
